import Layout from "@/containers/Layout";
import { ROUTES } from "@/routes_new";
import { Route, Switch, useParams } from "react-router-dom";
import Header from "./partials/header";
import AllEarsTitle from "@components/AllEarsTitle";
import { useLingui } from "@lingui/react/macro";
import SearchIndex from "./partials";
import { SearchProvider } from "./context";
import SearchPreview from "./preview";

export default function SearchView() {
  const { t } = useLingui();

  // URL state
  const { orgUuid } = useParams<{ orgUuid: string }>();

  return (
    <>
      <AllEarsTitle title={t`Sök`} />

      <Layout>
        <Header orgUuid={orgUuid} />

        <SearchProvider>
          <Switch>
            <Route exact path={ROUTES.SEARCH_ORGID} component={SearchIndex} />
            <Route
              path={ROUTES.SEARCH_PREVIEW_ORGID}
              component={SearchPreview}
            />
          </Switch>
        </SearchProvider>
      </Layout>
    </>
  );
}
